// import '../../../static/sdk/ol-debug.js';
// import '../../../static/sdk/zondyClient.js';
export default {
  name: 'drawTool',
  data() {
    return {
      gridDraws: "",
      gridDrawLayer: "",
      drawGrid: {
        fillColor: "rgba(255, 255, 255, 0.5)",
        borderColor: "#ff3359",
        borderWidth: 2
      },
      drawTool: new MilStd.tool.MilStdDrawTool(this.olmap),
      currentStyle: "",
      currentfeature: ""
    };
  },
  components: {
  },
  computed: {},
  props: {

  },
  watch: {
  },
  mounted() {
    this.drawTool.on(MilStd.event.MilStdDrawEvent.DRAW_END, this.onDrawEnd, false, this);
    this.init();
  },
  created() {
  },
  methods: {
    init() {
      var source = new this.$olmap.source.Vector();
      this.olmap.gridDrawLayer = new this.$olmap.layer.Vector({
        id: "draw_tool",
        zIndex: 1111,
        source: source,
        style: new this.$olmap.style.Style({ //图层样式
          fill: new this.$olmap.style.Fill({
            color: this.drawGrid.fillColor //填充颜色
          }),
          stroke: new ol.style.Stroke({
            color: this.drawGrid.borderColor, //边框颜色
            lineCap: "round",
            lineJoin: "round",
            lineDash: [0, 0],
            width: this.drawGrid.borderWidth // 边框宽度
          }),     //形状
          image: new ol.style.Circle({
            radius: this.drawGrid.borderWidth,
            fill: new ol.style.Fill({
              color: this.drawGrid.borderColor
            })
          })
        })
      });
      this.olmap.addLayer(this.olmap.gridDrawLayer);
    },
    /*绘制面 */
    drawArea(type) {
      this.olmap.drawOpt = true;

      if (type == "delete") {
        this.olmap.drawOpt = false;
        if (this.gridDraws) {
          this.olmap.removeInteraction(this.gridDraws);
        }
        if (this.olmap.gridDrawLayer) {
          this.olmap.gridDrawLayer.getSource().clear();
        }
        return;
      }
      this.initDraw(type);
      this.olmap.addInteraction(this.gridDraws);
      let that = this;
      this.gridDraws.on('drawend', function (evt) {
        // that.drawGrid.scope = evt.feature.getGeometry().getCoordinates().toString();
        that.olmap.removeInteraction(that.gridDraws);
        that.currentfeature = evt.feature;
        if (that.currentStyle) {
          that.currentfeature.setStyle(that.currentStyle);
        }
      })
    },

    initDraw(type) {

      //实例化一个矢量图层Vector作为绘制层
      // if (this.gridDraws) {
      //   this.olmap.removeInteraction(this.gridDraws);
      //  this.gridDrawLayer.getSource().clear();
      // }
      // this.init();
      var geometryFunction, maxPoints;
      if (type == "Box") {
        type = 'Circle';
        geometryFunction = ol.interaction.Draw.createBox()
      }
      this.gridDraws = new this.$olmap.interaction.Draw({
        type: type,
        source: this.olmap.gridDrawLayer.getSource(),
        //几何信息变更时调用函数
        geometryFunction: geometryFunction,
        //最大点数
        maxPoints: maxPoints
      });
    },

    //绘制军标
    drawArrow(type) {
    this.olmap.drawOpt = true;

      this.drawTool.deactivate();
      // if (this.gridDrawLayer) {
      //   this.gridDrawLayer.getSource().clear();
      // }
      // this.init();
      switch (type) {
        case "SimpleArrow":
          var milParam = new MilStd.MilstdParams({
            headHeightFactor: 0.15,
            headWidthFactor: 0.4,
            neckHeightFactor: 0.75,
            neckWidthFactor: 0.1,
            tailWidthFactor: 0.1,
            hasSwallowTail: true,
            swallowTailFactor: 0.1
          });
          this.drawTool.activate(MilStd.EnumMilstdType.SimpleArrow, milParam, "drawSimpleArrow");
          break;
        case "DoubleArrow":
          var milParam = new MilStd.MilstdParams({
            headHeightFactor: 0.15,
            headWidthFactor: 0.8,
            neckHeightFactor: 0.7,
            neckWidthFactor: 0.4
          });
          this.drawTool.activate(MilStd.EnumMilstdType.DoubleArrow, milParam, "drawDoubleArrow");
          break;
        case "StraightArrow":
          var milParam = new MilStd.MilstdParams({
            headHeightFactor: 0.1,
            headWidthFactor: 1.3,
            neckHeightFactor: 1.0,
            neckWidthFactor: 0.7,
            tailWidthFactor: 0.07,
            hasSwallowTail: false,
            swallowTailFactor: 0
          });
          this.drawTool.activate(MilStd.EnumMilstdType.StraightArrow, milParam, "drawStraightArrow");
          break;
        case "SingleLineArrow":
          var milParam = new MilStd.MilstdParams({
            headHeightFactor: 0.1,
            headWidthFactor: 1.3
          });
          this.drawTool.activate(MilStd.EnumMilstdType.SingleLineArrow, milParam, "drawdrawSingleLineArrow");
          break;
        case "TriangleFlag":
        case "RectFlag":
        case "CurveFlag":
          this.drawTool.activate(type, null, "drawFlag");
          break;
        //十字箭头指北针
        case "ArrowCross":
        //圆形尖角指北针
        case "CircleClosedangle":
        //尖角指北针
        case "Closedangle":
        //双向尖角指北针
        case "DoubleClosedangle":
        //四角指北针
        case "Fourstar":
        //菱形指北针
        case "Rhombus":
        //同向尖角指北针
        case "SameDirectionClosedangle":
        //三角指北针
        case "Triangle":
        //风向标指北针
        case "Vane":
          this.drawTool.activate(type, null, "drawCompass");
          break;
        //贝塞尔曲线成区
        case "Bezier":
        //贝塞尔曲线
        case "BezierLine":
        //集结区
        case "AssemblyArea":
          this.drawTool.activate(type, null, "drawBazier");
          break;
        default:
      }
    },
    //军标绘制完成后的回调
    onDrawEnd(event) {
      this.currentfeature = event.feature;
      if (this.currentStyle) {
        this.currentfeature.setStyle(this.currentStyle);
      }
      this.olmap.gridDrawLayer.getSource().addFeature(this.currentfeature);
    },

    styleChange(v, type) {
      if (type == "bC") {
        this.drawGrid.borderColor = v;
      }
      else if (type == "fC") {
        this.drawGrid.fillColor = v;
      }
      else if (type == "fW") {
        this.drawGrid.borderWidth = v;
      }
      if (this.olmap.gridDrawLayer) {
        this.currentStyle = new ol.style.Style({
          fill: new ol.style.Fill({
            color: this.drawGrid.fillColor //填充颜色
          }),
          stroke: new ol.style.Stroke({
            color: this.drawGrid.borderColor, //边框颜色
            lineCap: "round",
            lineJoin: "round",
            lineDash: [0, 0],
            width: this.drawGrid.borderWidth // 边框宽度
          }),
          image: new ol.style.Circle({
            radius: this.drawGrid.borderWidth,
            fill: new ol.style.Fill({
              color: this.drawGrid.borderColor
            })
          })
        });

        var len = this.olmap.gridDrawLayer.getSource().getFeatures().length;
        if (len > 0) {
          //this.currentfeature.setStyle(this.currentStyle);
          this.olmap.gridDrawLayer.getSource().getFeatures()[len - 1].setStyle(this.currentStyle);
        }
      }
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/drawTool/drawTool.js